export default {
  methods: {
    /**
     * Prepare an object to be used when sending quote requests.
     * 
     * @param  {String}  productCategory
     * @param  {Object}  product
     * @param  {Number}  quantity
     * @return {Object}
     */
    getProductDto(productCategory, product, quantity) {
      return {
        quantity,
        id: product.id,
        title: product.title,
        categoryName: productCategory,
        attributes: product.attributes,
      }
    }
  }
}
